export default "__VITE_ASSET__C0eS33hq__"